import { StatisticsViewerStore, STATISTICS_VIEWER_STORE } from 'store'
import { StyleProps } from 'utilities'

export type ViewerStatsProps = StyleProps & {
  [STATISTICS_VIEWER_STORE]?: StatisticsViewerStore
  renderDashboardVersion?: boolean
}

export enum ViewerEvents {
    TOTAL_WATCH = 'Total watch time',
    TOTAL_VOV_WATCH = 'Total VOV watch time',
    TOTAL_VOV_INTERACTION = 'Total VOV interaction time',
    TOTAL_INTERACTION = 'Total video interaction time',
    TOTAL_PAGE_INTERACTION_TIME = 'Total page interaction time',
    ADD_EXPENSES = 'Ad expenses',
    PURCHASE_REVENUE = 'Purchase revenue',
    ADD_REVENUE = 'Ad revenue'
}

export const viewerTabs: ViewerEvents[] = [ViewerEvents.TOTAL_WATCH,
  ViewerEvents.TOTAL_INTERACTION, ViewerEvents.ADD_REVENUE, ViewerEvents.PURCHASE_REVENUE]
